"use strict";

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var effects_1 = require("redux-saga/effects");

var http_action_1 = require("./http-action");

var http_helper_1 = require("./http-helper");

var http_type_1 = require("./http-type");

function request(action) {
  var _a, sagaHandler, callbackParams, id, serviceParams, service, _id, _b, task, resp;

  return __generator(this, function (_c) {
    switch (_c.label) {
      case 0:
        _a = action.payload, sagaHandler = _a.sagaHandler, callbackParams = _a.callbackParams, id = _a.id, serviceParams = _a.serviceParams, service = _a.service;
        _b = id;
        if (_b) return [3
        /*break*/
        , 2];
        return [4
        /*yield*/
        , effects_1.call(getRandomString)];

      case 1:
        _b = _c.sent();
        _c.label = 2;

      case 2:
        _id = _b; // Cancel current task with the same id

        return [4
        /*yield*/
        , effects_1.call(cancelRequest, http_action_1.httpCreators.cancel(_id))];

      case 3:
        // Cancel current task with the same id
        _c.sent(); // Request is going to start, set loading to true


        return [4
        /*yield*/
        , effects_1.put(http_action_1.httpCreators.setLoading(_id, true))];

      case 4:
        // Request is going to start, set loading to true
        _c.sent();

        return [4
        /*yield*/
        , effects_1.fork(service, {
          id: id,
          data: serviceParams
        })];

      case 5:
        task = _c.sent(); // Save task ref for cancellation mechanism

        return [4
        /*yield*/
        , effects_1.call(http_helper_1.HttpHelper.setCallTask, _id, task)];

      case 6:
        // Save task ref for cancellation mechanism
        _c.sent();

        return [4
        /*yield*/
        , effects_1.join(task)];

      case 7:
        resp = _c.sent(); // Set loading to false

        return [4
        /*yield*/
        , effects_1.put(http_action_1.httpCreators.setLoading(_id, false))];

      case 8:
        // Set loading to false
        _c.sent(); // Delete call task ref


        return [4
        /*yield*/
        , effects_1.call(http_helper_1.HttpHelper.deleteCallTask, _id)];

      case 9:
        // Delete call task ref
        _c.sent(); // Set failed result


        return [4
        /*yield*/
        , effects_1.put(http_action_1.httpCreators.setFailed(_id, !resp.success))];

      case 10:
        // Set failed result
        _c.sent(); // Forward to handler


        return [4
        /*yield*/
        , effects_1.call(sagaHandler ? sagaHandler : function () {}, resp, callbackParams)];

      case 11:
        // Forward to handler
        _c.sent();

        return [2
        /*return*/
        ];
    }
  });
}

function cancelRequest(action) {
  var id;
  return __generator(this, function (_a) {
    switch (_a.label) {
      case 0:
        id = action.payload; // Cancel axios request

        return [4
        /*yield*/
        , effects_1.call(http_helper_1.HttpHelper.cancel, id)];

      case 1:
        // Cancel axios request
        _a.sent();

        if (!http_helper_1.HttpHelper.getCallTask(id)) return [3
        /*break*/
        , 3];
        return [4
        /*yield*/
        , effects_1.cancel(http_helper_1.HttpHelper.getCallTask(id))];

      case 2:
        _a.sent();

        _a.label = 3;

      case 3:
        // Remove task ref
        return [4
        /*yield*/
        , effects_1.call(http_helper_1.HttpHelper.deleteCallTask, id)];

      case 4:
        // Remove task ref
        _a.sent(); // Clear loading, failed flags


        return [4
        /*yield*/
        , effects_1.put(http_action_1.httpCreators.setLoading(id, false))];

      case 5:
        // Clear loading, failed flags
        _a.sent();

        return [4
        /*yield*/
        , effects_1.put(http_action_1.httpCreators.setFailed(id, false))];

      case 6:
        _a.sent();

        return [2
        /*return*/
        ];
    }
  });
}

function getRandomString() {
  return "" + Math.random().toString(36).substr(2, 5) + new Date().getTime().toString();
}

exports.httpSagas = {
  request: request,
  cancelRequest: cancelRequest,
  getRandomString: getRandomString,
  watchers: [effects_1.takeEvery(http_type_1.HTTP_ACTION_TYPE.REQUEST, request), effects_1.takeEvery(http_type_1.HTTP_ACTION_TYPE.CANCEL, cancelRequest)]
};